import webLink from '../../Assets/images/links/globe2.svg';
import dribbbleLink from '../../Assets/images/links/dribbble.svg';
import ytLink from '../../Assets/images/links/youtube.svg';

import bastide from '../../Assets/images/projects/bastide.com.jpg';
import brooksandfalotico from '../../Assets/images/projects/brooksandfalotico.com.jpg';
import casangelina from '../../Assets/images/projects/casangelina.com.jpg';
import eu54celsius from '../../Assets/images/projects/eu.54celsius.com.jpg';
import novoholdings from '../../Assets/images/projects/novoholdings.dk.jpg';
import scuitstore from '../../Assets/images/projects/scuit store.png';
import tektiles from '../../Assets/images/projects/tektiles.png';
import tdinsurance from '../../Assets/images/projects/td insurance.png';
import truenorth from '../../Assets/images/projects/truenorth.png';
import tenco from '../../Assets/images/projects/tenco construction company.png';
import floridapoly from '../../Assets/images/projects/florida poly.png';
import aipoma from '../../Assets/images/projects/aipoma.png';

import health from '../../Assets/images/projects/best expatscover.png';
import hugeinc from '../../Assets/images/projects/hugeinc.com.jpg';
import roclivelifeloud from '../../Assets/images/projects/roclivelifeloud.com.jpg';
import bluesdco from '../../Assets/images/projects/blues-d.co.jp.jpg';
import smarthome from '../../Assets/images/projects/smarthome.png';
import godofwar from '../../Assets/images/projects/godofwar.png';
import itlogo from '../../Assets/images/projects/intimelogo.png';
import nyoologo from '../../Assets/images/projects/ntoologo.png';
import mplogo from '../../Assets/images/projects/mplogo.png';
import discoverro from '../../Assets/images/projects/discover-ro.png';
import vclp from '../../Assets/images/projects/vclp.png';
import vibenow from '../../Assets/images/projects/vibenow.png';
import kinsta from '../../Assets/images/projects/kinsta.jpg';
import globaxlimousine from '../../Assets/images/projects/globaxlimousine.com.jpg';
import analytics from '../../Assets/images/projects/google analytics.jpg';

import tla from '../../Assets/images/projects/tla.png';
import arlgtv from '../../Assets/images/projects/arlg.png';
import arop7 from '../../Assets/images/projects/arop7.png';
import castleescape from '../../Assets/images/projects/castleescape.png';
// import geex from '../../Assets/images/projects/geex.png';
// import arbachelor from '../../Assets/images/projects/bachelor.png';
// import ardissertation from '../../Assets/images/projects/dissertation.png';

export const web = [
	{
		name: 'scuti.store',
		cover: scuitstore,
		links: [{ icon: webLink, link: 'https://scuti.store' }],
	},
	{
		name: 'www.tektiles.com',
		cover: tektiles,
		links: [{ icon: webLink, link: 'http://www.tektiles.com' }],
	},
	{
		name: 'www.tdinsurance.com',
		cover: tdinsurance,
		links: [{ icon: webLink, link: 'https://www.tdinsurance.com' }],
	},
	{
		name: 'truenorth.co',
		cover: truenorth,
		links: [{ icon: webLink, link: 'https://truenorth.co' }],
	},
	{
		name: 'www.tencoconstructionco.com',
		cover: tenco,
		links: [{ icon: webLink, link: 'http://www.tencoconstructionco.com' }],
	},
	{
		name: 'floridapoly.edu',
		cover: floridapoly,
		links: [{ icon: webLink, link: 'https://floridapoly.edu' }],
	},
	{
		name: 'aipoma.com',
		cover: aipoma,
		links: [{ icon: webLink, link: 'https://aipoma.com' }],
	},
	{
		name: 'bastide.com',
		cover: bastide,
		links: [{ icon: webLink, link: 'https://bastide.com' }],
	},
	{
		name: 'brooksandfalotico.com',
		cover: brooksandfalotico,
		links: [{ icon: webLink, link: 'https://brooksandfalotico.com' }],
	},
	{
		name: 'casangelina.com',
		cover: casangelina,
		links: [{ icon: webLink, link: 'https://casangelina.com' }],
	},
	{
		name: 'eu.54celsius.com',
		cover: eu54celsius,
		links: [{ icon: webLink, link: 'https://eu.54celsius.com' }],
	},
	{
		name: 'novoholdings.com',
		cover: novoholdings,
		links: [{ icon: webLink, link: 'https://novoholdings.dk' }],
	},
	{
		name: 'Smart Home Dashboard UI',
		date: '2022-04-03',
		cover: smarthome,
		links: [{ icon: dribbbleLink, link: 'https://dribbble.com/shots/17912071-Smart-Home-Dashboard-UI' }],
	},
	{
		name: 'God of War Concept UI',
		date: '2022-03-13',
		cover: godofwar,
		links: [{ icon: dribbbleLink, link: 'https://dribbble.com/shots/17710279-God-of-War-Website-design' }],
	},
	{
		name: 'In time Logo',
		date: '2020-04-20',
		cover: itlogo,
		links: [{ icon: dribbbleLink, link: 'https://dribbble.com/shots/16788202-IN-TIME-Logo-design' }],
	},
	{
		name: 'NY Open Offices Logo',
		date: '2018-05-12',
		cover: nyoologo,
		links: [{ icon: dribbbleLink, link: 'https://dribbble.com/shots/18038998-New-York-Open-Offices-Logo-design' }],
	},
	{
		name: 'Midnight Pulse Logo',
		date: '2018-07-17',
		cover: mplogo,
		links: [{ icon: dribbbleLink, link: 'https://dribbble.com/shots/18302655-Midnight-Pulse-Logo-design' }],
	},
	{
		name: 'Discover Romania Concept UI',
		date: '2022-06-05',
		cover: discoverro,
		links: [
			{ icon: dribbbleLink, link: 'https://dribbble.com/shots/18413927-Discover-Romania-Landing-page' },
			{ icon: ytLink, link: 'https://www.youtube.com/watch?v=vzyxaw_ryyQ' },
		],
	},
	{
		name: 'Vice City Conceput UI',
		date: '2022-08-14',
		cover: vclp,
		links: [
			{ icon: dribbbleLink, link: 'https://dribbble.com/shots/19100552-Welcome-back-to-Vice-City-Landing-page' },
			{ icon: ytLink, link: 'https://www.youtube.com/watch?v=ysBkWUQMLHQ' },
		],
	},
	{
		name: 'Vibe Now UI',
		date: '2022-10-28',
		cover: vibenow,
		links: [
			{ icon: dribbbleLink, link: 'https://dribbble.com/shots/20106594-Vibe-Now-Mobile-app-for-events' },
		],
	},
	{
		name: 'hugeinc.com',
		cover: hugeinc,
		links: [{ icon: webLink, link: 'https://hugeinc.com' }],
	},
	{
		name: 'roclivelifeloud.com',
		cover: roclivelifeloud,
		links: [{ icon: webLink, link: 'https://roclivelifeloud.com' }],
	},
	{
		name: 'blues-d.co.jp',
		cover: bluesdco,
		links: [{ icon: webLink, link: 'https://blues-d.co.jp' }],
	},
];

export const game = [
	{
		name: 'The Last Ancient',
		date: '2017-05-01',
		cover: tla,
		links: [{ icon: webLink, link: 'https://halfroundgames.itch.io/the-last-ancient' }],
	},
	// { name: "Bachelor's degree AR project", date: '2018-07-20', cover: arbachelor, links: [] },
	// { name: "Master's degree AR project", date: '2020-07-20', cover: ardissertation, links: [] },
	{
		name: 'LG Rollable TV AR project',
		date: '2019-01-23',
		cover: arlgtv,
		links: [{ icon: ytLink, link: 'https://www.youtube.com/watch?v=bn69s8lOCCU&t=26s' }],
	},
	{
		name: 'Oneplus 7 AR project',
		date: '2019-05-21',
		cover: arop7,
		links: [{ icon: ytLink, link: 'https://www.youtube.com/watch?v=188qht5Sg8k' }],
	},
	{
		name: 'Castle Escape',
		date: '2018-12-20',
		cover: castleescape,
		links: [{ icon: ytLink, link: 'https://www.youtube.com/watch?v=u_s-hL78goQ' }],
	},
];

export const design = [
	{
		name: 'bestexpatscover.com',
		cover: health,
		links: [{ icon: webLink, link: 'https://bestexpatscover.com' }],
	},
	{
		name: 'kinsta.com',
		cover: kinsta,
		links: [{ icon: webLink, link: 'https://kinsta.com' }],
	},
	{
		name: 'globaxlimousine.com',
		cover: globaxlimousine,
		links: [{ icon: webLink, link: 'https://globaxlimousine.com' }],
	},
	{
		name: 'Google Analytics',
		cover: analytics,
		links: [{ icon: webLink, link: 'https://sebetc.com' }],
	},
];

